import * as React from 'react';

const CheckmarkShield24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M11.999 1c2.496 0 4.971 1.87 7.394 2.315.825.151 1.612.867 1.607 1.88-.009 1.77-.025 5.843-.025 6.733 0 4.595-4.144 8.18-7.564 10.616A2.43 2.43 0 0 1 12 23a2.43 2.43 0 0 1-1.413-.456c-3.42-2.435-7.562-6.02-7.562-10.616 0-.89-.016-4.962-.025-6.733-.005-1.013.782-1.729 1.607-1.88C7.03 2.87 9.502 1 12 1Zm5.254 8.032a1.04 1.04 0 0 0-.128-1.438.98.98 0 0 0-1.404.13l-4.22 5.187-2.225-2.735a.98.98 0 0 0-1.404-.131 1.04 1.04 0 0 0-.128 1.438l2.991 3.678a.992.992 0 0 0 1.532 0z"
  }
));
CheckmarkShield24.Size = 24;
CheckmarkShield24.Title = "CheckmarkShield";

export { CheckmarkShield24 as default };
